import { render, staticRenderFns } from "./vidobox.vue?vue&type=template&id=f60046a8&scoped=true"
import script from "./vidobox.vue?vue&type=script&lang=js"
export * from "./vidobox.vue?vue&type=script&lang=js"
import style0 from "./vidobox.vue?vue&type=style&index=0&id=f60046a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.27_css-loader@6.11.0_webpack@5.104.1__lodash@4.17.23_headix2sp25l5o3ug274cuzz24/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60046a8",
  null
  
)

export default component.exports